/**
 * External Imports
 */
import { Link } from 'react-router-dom';
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton, NeuNavigation, NeuTab } from '@neutron/react';

interface IDropdownProps {
  isHelpDropdownOpen?: boolean;
  showPopover?: boolean;
}

interface IPopContentProps {
  justify?: string;
}

export const MainToolbar = styled(NeuNavigation)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 16px;
  position: relative;
  width: 100%;
  height: 68px;
  left: 0px;
  top: 0px;
  background: #06173d;
`;

export const NavTabs = styled(NeuTab)`
  justify-content: flex-start;
  color: #f6f6f6;
  flex-grow: 6;
  font-size: 14px;
  font-weight: bold;
  margin-left: -10px !important;
  @media (min-width: 768px) {
    display: inline-flex !important;
  }
`;

export const DropDownContainer = styled.div<IDropdownProps>`
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  margin: 0px 10px;
  width: 180px;
  min-height: max-content;
  z-index: 20;
  position: absolute;
  top: 58px;
  left: -5px;
  background: white !important;
  opacity: 1;
  display: ${props => (props.showPopover ? 'block' : 'none')};
`;

export const PopContent = styled.div<IPopContentProps>`
  display: flex;
  align-items: center;
  justify-content: ${props =>
    props.justify ? props.justify : 'space-between'};
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: var(--primary-60);
`;

export const PopItem = styled.div`
  color: var(--primary-60);
  font-weight: bold;
`;

export const StyledLink = styled(Link)`
  &:active,
  &:hover {
    --link-background: transparent !important;
  }
`;

export const StyledNavTab = styled(NeuTab)`
  font-size: 0.9375rem !important;
  flex-direction: column;
  justify-content: center;
  padding-left: 0.6rem !important;
  padding-right: 0.6rem !important;
  &:active,
  &:hover {
    --link-background: transparent !important;
  }
`;

export const UserNavTab = styled(NeuTab)<{ active?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 0.8125rem !important;
  height: auto;
  min-width: 4em;
  transition: all 0.25s ease-in-out;
  &:active {
    color: rgb(255, 255, 255) !important;
    font-weight: 700;
  }
  &:hover {
    color: rgb(255, 255, 255) !important;
    font-weight: 700;
  }
  ${props =>
    props.active
      ? 'color: rgb(255, 255, 255) !important; font-weight: 700;'
      : ''}
`;

export const LogoLink = styled.a`
  font-size: 16px;
  &:active,
  &:focus,
  &:hover {
    --link-background: transparent !important;
  }
`;

export const LogoImg = styled.img`
  margin-right: 0.5rem;
`;

export const AdhocBtnContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const RightMainNavContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const AddNewButton = styled(NeuButton)`
  background-color: white !important;
  color: rgb(0, 119, 181) !important;
  --hover: rgb(211, 233, 194) !important;
`;

export const UserControls = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: start;
  flex-shrink: 0;
  align-items: center;
  color: #ffffff;
  font-size: 0.875rem;
`;

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 5rem;
  color: #ffffff;
  font-size: 0.8125rem;
  margin-left: 0.75rem;
  text-align: right;
`;
